module.exports = __webpack_public_path__ + "assets/img/Compose_Capture.9a28dbe5.svg";